import { FaApple, FaGooglePlay } from 'react-icons/fa';
import { ANDROID_PLAY_STORE_URL, IOS_APP_STORE_URL } from '@/lib/store';
import { track } from '@/lib/analytics';

type StoreBadgesProps = {
  source: string;
  variant?: 'cream' | 'primary';
};

export function StoreBadges({ source, variant = 'primary' }: StoreBadgesProps) {
  const classes =
    variant === 'cream'
      ? 'bg-cream text-primary hover:bg-cream-dark'
      : 'bg-primary text-white hover:bg-primary-hover';

  return (
    <div className="flex w-full flex-col gap-3 sm:flex-row">
      <a
        href={IOS_APP_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => track('Landing Store Press', { store: 'ios', source })}
        className={`inline-flex flex-1 items-center justify-center gap-2 rounded-lg px-8 py-4 text-lg font-semibold transition-all hover:scale-105 hover:shadow-xl ${classes}`}
        style={{ fontFamily: "'Nunito', system-ui, sans-serif" }}
      >
        <FaApple size={20} aria-hidden />
        App Store
      </a>
      <a
        href={ANDROID_PLAY_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => track('Landing Store Press', { store: 'android', source })}
        className={`inline-flex flex-1 items-center justify-center gap-2 rounded-lg px-8 py-4 text-lg font-semibold transition-all hover:scale-105 hover:shadow-xl ${classes}`}
        style={{ fontFamily: "'Nunito', system-ui, sans-serif" }}
      >
        <FaGooglePlay size={20} aria-hidden />
        Google Play
      </a>
    </div>
  );
}
